<template>
	<div class="modal-body">
		<h5>Choose a Fibre Provider.</h5>
		<form v-if="providers" class="provider-cards" :class="`card-size-${providers.length}`">
			<label class="provider-card" v-for="(provider, index) in providers" :key="provider.id" :class="{'is-selected': index === selectedProvider}">
				<input type="radio" :value="index" name="provider" v-model="selectedProvider">
				<div class="card-logo"><svg><use :xlink:href="`#provider-${provider.slug}`"></use></svg></div><!-- end.card-logo -->
				<div class="card-footer grey-bg">Starting from R{{ provider.products[0].price }} pm</div><!-- end.card-footer -->
			</label>
		</form>
		<div class="modal-footer">
			<button class="btn white" @click.prevent="$router.back()">Go Back</button>
			<button class="btn gradient-red" @click.prevent="next()" :disabled="selectedProvider === false">Next</button>
		</div><!-- end.modal-footer -->
	</div><!-- end.modal-body -->
</template>
<script>

	export default {
		computed: {
			availableProviders() {
				return this.$store.getters['coverage/availableFibreProviders']
			},
			providers() {
				let availProviders = this.availableProviders;
				let allProviders = this.$store.getters['providers/providers'];
				let availProviderSlugs = availProviders.map(p => p.vendor.slug);

				return allProviders.filter(p => {
					return availProviderSlugs.indexOf(p.vendor_slug) >= 0;
				});
			},
		},
		data() {
			return {
				selectedProvider: false,
			}
		},
		methods: {
			next() {
				if(this.selectedProvider === false) {
					return false;
				}

				let selectedProvider = this.availableProviders.find(p => {
					return this.providers[this.selectedProvider].vendor_slug === p.vendor.slug;
				});
				this.$store.commit('coverage/setFibreProvider', selectedProvider);
				this.$router.push({name: 'packages'});
			}
		},
		mounted() {
			// @TODO - Check if the user is on the single provider page
			if(this.providers && this.providers.length === 1) {
				this.selectedProvider = 0;
				this.next();
			}
		}
	}
</script>
